export default __webpack_public_path__ + "static/media/3.797b90bb.png";